function configureLineChatbotSubscriptionCheck(opts) {
  const { analytics, gcinstant, replicantClientPromise } = opts;
  const isValidPlatform = gcinstant.platformID === "line" || gcinstant.platformID === "web";
  if (!isValidPlatform) {
    throw Error("Invalid platform: " + gcinstant.platformID);
  }
  const isSubscribedPromise = replicantClientPromise.then(
    async (replicant) => {
      if (replicant.platform !== "line") {
        return null;
      }
      const asyncGetter = replicant.asyncGetters.lineIsSubscribedToChatbot;
      if (!asyncGetter) {
        console.error(
          "No lineIsSubscribedToChatbot async getter found in configuration - make sure to extend Replicant configuration with extendReplicantConfigForAnalytics"
        );
        return null;
      }
      return asyncGetter();
    }
  );
  async function setChatbotSubscriptionStatus() {
    try {
      const isSubscribed = await isSubscribedPromise;
      if (isSubscribed === null) {
        return;
      }
      gcinstant.isSubscribedToBot = isSubscribed;
      analytics.setUserProperties({ isSubscribed });
      const canSubscribeBot = !isSubscribed;
      gcinstant.canSubscribeToBot = canSubscribeBot;
      analytics.setUserProperties({ canSubscribeBot });
    } catch {
    }
  }
  gcinstant.beforeStartGameAsync(setChatbotSubscriptionStatus);
}
export {
  configureLineChatbotSubscriptionCheck
};
